import React from 'react';
import styles from './Tooltip.css';

const Tooltip = ({
  index,
  step,
  backProps,
  primaryProps,
  tooltipProps,
  size,
}) => (
  <div {...tooltipProps} className={styles.container}>
    <div className={styles['tooltip-body']}>
      {step.title && <div className={styles.title}>{step.title}</div>}
      {step.content && <div className={styles.content}>{step.content}</div>}
    </div>
    <div className={styles['tooltip-footer']}>
      <div className={styles.step}>{`${index + 1}/${size}`}</div>
      {index > 0 && (
        <button className={styles['back-button']} {...backProps}>
          {step.locale.back}
        </button>
      )}

      <button className={styles['next-button']} {...primaryProps}>
        {step.locale.next}
      </button>
    </div>
  </div>
);

export default Tooltip;
